import React from 'react';
import ChartistGraph from 'react-chartist';
import './chartist-custom-style.css';
import moment from 'moment';
import Chartist from 'chartist';
import * as ChartistTooltips from 'chartist-plugin-tooltips';
import {Box} from '@mui/material';
import {primaryColor} from '../assets/jss/nextjs-material-dashboard';


const delays = 80,
  durations = 500;

export default function WaterMiniChart({height, max, data, measurement}) {
  const dataLen = data.length;
  const dateStart = dataLen ? moment(data[0].timestamp) : moment();
  const dateMiddle = dataLen ? moment(data[dataLen / 2].timestamp) : moment();
  const dateEnd = dataLen ? moment(data[dataLen - 1].timestamp) : moment();

  Array.from(document.getElementsByClassName('chartist-tooltip')).map(elem => {
    elem.style['opacity'] = 0;
  });

  return <Box position={'relative'}><ChartistGraph
    type="Line"
    data={{...DefaultData(dateStart, dateMiddle, dateEnd, dataLen), series: [data]}}
    options={{...options, height, showPoint: dataLen < 300}}
    responsiveOptions={responsiveOptions}
    listener={animationRaise}
  /></Box>;
}

var defaultTooltipOptions = {
  currency: undefined, //accepts '£', '$', '€', etc.
  //e.g. 4000 => €4,000
  tooltipFnc: (meta, valueStr) => {
    // console.log({meta, valueStr});
    Array.from(document.getElementsByClassName('chartist-tooltip')).map(elem => {
      elem.style['opacity'] = 1;
    });
    return `     
                <span class="MuiTypography-root MuiTypography-body2 css-1insige-MuiTypography-root" style="color: ${window.chartistTooltipColor || primaryColor[2]}; margin-bottom: 10px;">
                   <b>   ${parseFloat(valueStr).toFixed(1)}</b>  ${window.chartistTooltipUnits}
                </span>
                 <br/>
                <span class="MuiTypography-root MuiTypography-caption css-eir2f-MuiTypography-root" style="color: ${window.chartistTooltipColor || primaryColor[2]};">
                    ${meta} 
                </span>
`;
  }, //accepts function
  // //build custom tooltip
  // transformTooltipTextFnc: (arg1, arg2, arg3) => {
  //   console.log({arg1, arg2,arg3});
  //   return <p>TESTSSTSTSTST</p>
  // }, // accepts function
  // transform tooltip text
  // pointClass: 'my-cool-point',
  class: undefined, // accecpts 'class1', 'class1 class2', etc.
  //adds class(es) to tooltip wrapper
  anchorToPoint: true, //accepts true or false
  //tooltips do not follow mouse movement -- they are anchored to the point / bar.
  appendToBody: false //accepts true or false
  //appends tooltips to body instead of chart container
};

const DefaultData = (dateStart, dateMiddle, dateEnd, dataLen) => ({
  labels: [
    `${dateStart.format('DD.MM.YYYY HH:00')}`,
    ...Array.from({length: dataLen / 2 - 1}, () => ''),
    `${dateMiddle.format('DD.MM.YYYY HH:00')}`,
    ...Array.from({length: dataLen / 2 - dataLen / 8}, () => ''),
    `${dateEnd.format('DD.MM.YYYY HH:00')}`,
  ],
  series: [
    [
      10, 20, 30, 40, 50, 60, 80, 70, 40, 30, 20, 50,
      10, 20, 30, 40, 50, 60, 80, 70, 55, 40, 30, 20,
    ]
  ],
});

const options = {
  axisX: {
    showGrid: false,
  },
  // height:'200px',
  height: '100px',
  // low: 0,
  high: null,
  radius: 1,
  chartPadding: {
    top: 20,
    right: 0,
    bottom: 0,
    left: 10,
  },
  plugins: [
    Chartist.plugins.tooltip(defaultTooltipOptions)
  ]
};

const responsiveOptions = [
  [
    'screen and (max-width: 767px)',
    {
      axisX: {
        // labelInterpolationFnc: function (value) {
        // console.log({value});
        // return new Date(value[0]).toLocaleString();
        // return value;
        // },
      },
    },
  ],
];

const animationRaise = {
  draw: function (data) {
    // console.log({dataElement: data.element});
    if (data.type === 'line' || data.type === 'area') {
      data.element.animate({
        d: {
          begin: 600,
          dur: 700,
          from: data.path
            .clone()
            .scale(1, 0)
            .translate(0, data.chartRect.height())
            .stringify(),
          to: data.path.clone().stringify(),
        },
      });
    } else if (data.type === 'point' && data.series.length < 30) {
      data.element.animate({
        opacity: {
          begin: (data.index + 1) * delays,
          dur: durations,
          from: 0,
          to: 1,
          easing: 'ease',
        },
      });
    }
    else if (data.type === 'point' && data.series.length > 60) {
      // if(data.element.style) data.element.style['opacity'] = 0;
      data.element.animate({
        opacity: {
          from: 0,
          to: 0
          // easing: 'ease'
        }
      });
    }
  },

};

const animationOpacity = {
  draw: function (data) {
    if (data.type === 'line') {
      data.element.animate({
        opacity: {
          begin: (data.index + 1) * delays,
          dur: durations,
          from: 0,
          to: 1,
          easing: 'ease',
        },
      });
    }
  },
};
